import { render, staticRenderFns } from "./Hover.vue?vue&type=template&id=3c87ca42&scoped=true"
import script from "./Hover.vue?vue&type=script&lang=ts"
export * from "./Hover.vue?vue&type=script&lang=ts"
import style0 from "./Hover.vue?vue&type=style&index=0&id=3c87ca42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c87ca42",
  null
  
)

export default component.exports